/**
 * The restrained, weight-driven type scale the v3 booking page uses.
 * Anchored on a 14px body. Labels sit at body size and rely on colour for
 * label/value contrast, so prefer these over ad-hoc fontSize props.
 */
const textStyles = {
  display: {
    fontSize: "28px",
    lineHeight: 1.2,
    fontWeight: 700,
    letterSpacing: "-0.01em",
  },
  heading: {
    fontSize: "16px",
    lineHeight: 1.3,
    fontWeight: 600,
    letterSpacing: "-0.006em",
  },
  title: { fontSize: "16px", lineHeight: 1.3, fontWeight: 600 },
  section: {
    fontSize: "12px",
    lineHeight: 1.2,
    fontWeight: 600,
    letterSpacing: "0.01em",
  },
  body: { fontSize: "14px", lineHeight: 1.45 },
  label: { fontSize: "14px", lineHeight: 1.4 },
  caption: { fontSize: "12px", lineHeight: 1.35 },
}

export default textStyles
